import { Writer } from './Writer'
import { withWriter } from './withWriter'

const ConnectedWriter = withWriter(Writer)

export { ConnectedWriter as Writer }
